<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-xl-8">
        <div class="row">
            <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body">
                    <div class="row">
                        <h5 class="text-black font-size-14 col-lg-12 text-center">
                            <strong>งบประมานรวม (บาท)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#7F7F7F">10,000,000</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body">
                    <div class="row">
                        <h5 class="text-black font-size-14 col-lg-12 text-center">
                            <strong>เบิกจ่ายแล้ว (บาท)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#8AA259">6,500,000</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body">
                    <div class="row">
                        <h5 class="text-black font-size-14 col-lg-12 text-center">
                            <strong>งบประมานคงเหลือ (บาท)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#EA701F">3,500,000</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="row">
         <h5 class="text-black col-lg-12">
           <div class="divider left">
              <hr />
              <label>โครงการทั้งหมด</label>
            </div>
        </h5>
         <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body" style="background: #31859B;">
                    <div class="row">
                        <h5 class="text-white font-size-14 col-lg-12 text-center">
                            <strong style="white-space: nowrap;margin-left:-10;margin-left: -10px;">อยู่ระหว่างจัดจ้าง (โครงการ)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#FFFFFF">6/20</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
           <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body" style="background: #31859B;">
                    <div class="row">
                        <h5 class="text-white font-size-14 col-lg-12 text-center">
                            <strong style="white-space: nowrap;margin-left:-10;margin-left: -10px;">อยู่ระหว่างเบิกจ่าย (โครงการ)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#FFFFFF">9/20</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body" style="background: #31859B;">
                    <div class="row">
                        <h5 class="text-white font-size-14 col-lg-12 text-center">
                            <strong style="white-space: nowrap;">กำเนินการแล้วเสร็จ (โครงการ)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#FFFFFF">5/20</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="row">
         <h5 class="text-black col-lg-12">
           <div class="divider left">
              <hr />
              <label>โครงการภายในปีงบประมาน</label>
            </div>
        </h5>
         <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body" style="background: #008039;">
                    <div class="row">
                        <h5 class="text-white font-size-14 col-lg-12 text-center">
                            <strong style="white-space: nowrap;margin-left:-10;margin-left: -10px;">อยู่ระหว่างจัดจ้าง (โครงการ)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#FFFFFF">3/10</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
           <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body" style="background: #008039;">
                    <div class="row">
                        <h5 class="text-white font-size-14 col-lg-12 text-center">
                            <strong style="white-space: nowrap;margin-left:-10;margin-left: -10px;">อยู่ระหว่างเบิกจ่าย (โครงการ)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#FFFFFF">4/10</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body" style="background: #008039;">
                    <div class="row">
                        <h5 class="text-white font-size-14 col-lg-12 text-center">
                            <strong style="white-space: nowrap;">กำเนินการแล้วเสร็จ (โครงการ)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#FFFFFF">2/10</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="row">
         <h5 class="text-black col-lg-12">
           <div class="divider left">
              <hr />
              <label>โครงการเหลื่อมปีงบประมาน</label>
            </div>
        </h5>
         <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body" style="background: #EA700D;">
                    <div class="row">
                        <h5 class="text-white font-size-14 col-lg-12 text-center">
                            <strong style="white-space: nowrap;margin-left:-10;margin-left: -10px;">อยู่ระหว่างจัดจ้าง (โครงการ)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#FFFFFF">3/10</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
           <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body" style="background: #EA700D;">
                    <div class="row">
                        <h5 class="text-white font-size-14 col-lg-12 text-center">
                            <strong style="white-space: nowrap;margin-left:-10;margin-left: -10px;">อยู่ระหว่างเบิกจ่าย (โครงการ)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#FFFFFF">4/10</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="col-lg-12 col-xl-4">
                <div class="card">
                <div class="card-body" style="background: #EA700D;">
                    <div class="row">
                        <h5 class="text-white font-size-14 col-lg-12 text-center">
                            <strong style="white-space: nowrap;">กำเนินการแล้วเสร็จ (โครงการ)</strong>
                        </h5>
                        <div class="col-lg-12 font-size-16 text-center">
                            <span class="font-weight-bold" style="font-size:30px;"><span  style="color:#FFFFFF">2/10</span></span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="row">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-center font-size-16">
                <span class="text-muted">
                  <strong>แสดงสถิติการเบิกจ่ายงบประมาน ประจำปี พ.ศ. 2563</strong>
                </span>
              </div>
              <div class="col-lg-12">
                <!-- <vue-c3 :handler="barValue" class="height-200"></vue-c3> -->
                <bar-chart :chartdata="barData" :options="barOptions" :height="100" />
              </div>
            </div>
          </div>
        </div>
        </div>
     </div>
      <div class="col-lg-12 col-xl-4">
          <div class="col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-center font-size-16">
                <span class="text-muted">
                  <strong>แผนภาพงบประมาณปละการเบิกจ่าย</strong>
                </span>
              </div>
              <div class="col-lg-12">
                <!-- <vue-c3 :handler="bar" class="height-530"></vue-c3> -->
                 <vue-c3 :handler="barRotated" class="height-700"></vue-c3>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueC3 from "vue-c3";
import "c3/c3.min.css";
import BarChart from './BarChart.vue'
const barData = {
  labels: ["ม.ค.", "ก.พ.", "ม.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
  datasets: [
    {
      label: 'data',
      backgroundColor: "#FE8E2C",
      borderColor: "#FE8E2C",
      borderWidth: 1,
      data: [4, 5, 8, 4, 1, 2, 8, 5, 10, 3, 1, 3],
    },
  ],
}
const barOptions = {
  scales: {
    xAxes: [
      {
        stacked: true,
      },
    ],
    yAxes: [
      {
        stacked: true,
      },
    ],
  },
}
export default {
  components: {
    VueC3,
    BarChart,
  },
  data: function() {
    return {
      barRotated: new Vue(),
      // barValue: new Vue(),
      barData,
      barOptions,
      colors: {
        primary: '#01a8fe',
        def: '#acb7bf',
        success: '#46be8a',
        danger: '#fb434a',
      },
    };
  },
  computed: {
    // barValuesOptions() {
    //   return {
    //     data: {
    //       columns: [
    //         ['data', 4, 5, 8, 4, 1, 2, 8, 5, 10, 3, 1, 3]
    //       ],
    //       types: {
    //         data: 'bar'
    //       },
    //       colors: {
    //         data: '#FE8E2C',
    //       }
    //     },
    //   };
    // },
    barRotatedOptions() {
      return {
        data: {
          columns: [
            ['Danger', 30, 200, 100, 400, 150, 250],
            ['Default', 130, 100, 140, 200, 150, 50],
          ],
          type: 'bar',
        },
        bar: {
          width: {
            max: 20,
          },
        },
        color: {
          pattern: [this.colors.danger, this.colors.def]
        },
        axis: {
          rotated: true
        },
        grid: {
          y: {
            show: !0
          },
          x: {
            show: !1
          }
        }
      }
    }
  },
  mounted() {
    // this.barValue.$emit("init", this.barValuesOptions);
    this.barRotated.$emit("init", this.barRotatedOptions);
  }
};
</script>
<style scoped>
.card-body {
  padding: 0.50rem .25rem 0.25rem .25rem;
}
.divider {
  display: flex;
  flex-direction: row;
  flex-flow: row;
  width: 100%;
}
.divider > label {
  align-self: baseline;
  flex-grow: 2;
  white-space: nowrap;
}
.divider > hr {
  margin-top: 10px;
  width: 100%;
  border: 0;
  height: 1px;
  background: #E5E5E5;
}

.divider.left > label {
  order: 1;
  padding-right: 5px;
}
.divider.left > hr {
  order: 2
}
</style>
